import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-3xl font-extrabold mb-2" }, "Mutasi Bus"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-normal text-grey" }, "Anda dapat menukar trayek antar bus")
], -1)
const _hoisted_2 = { class: "mb-3 md:px-10 p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HorizontalStepper = _resolveComponent("HorizontalStepper")!
  const _component_MutationInfoForm = _resolveComponent("MutationInfoForm")!
  const _component_SelectNewTrayekMutationForm = _resolveComponent("SelectNewTrayekMutationForm")!
  const _component_MutationFormReview = _resolveComponent("MutationFormReview")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HorizontalStepper, {
        items: _ctx.steps,
        value: _ctx.selectedStep
      }, null, 8, ["items", "value"])
    ]),
    (_ctx.selectedStep === 1)
      ? (_openBlock(), _createBlock(_component_MutationInfoForm, {
          key: 0,
          onHideSidebar: _ctx.hideSidebar,
          onOnSubmit: _ctx.onSubmit
        }, null, 8, ["onHideSidebar", "onOnSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.selectedStep === 2)
      ? (_openBlock(), _createBlock(_component_SelectNewTrayekMutationForm, {
          key: 1,
          onSetformPosition: _ctx.setformPosition,
          onOnSubmit: _ctx.hideSidebar
        }, null, 8, ["onSetformPosition", "onOnSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.selectedStep === 3)
      ? (_openBlock(), _createBlock(_component_MutationFormReview, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}